import type { MajorGradeInterface } from "../legacyStorageTypes";
const majorGradeCoefficient = 1000;

export class MajorGrade implements MajorGradeInterface {
  majorId: number;
  grade: number;

  constructor(majorId: number, grade: number) {
    this.majorId = majorId;
    this.grade = grade;
  }

  getKeyOfMajorGrade(): string {
    if (this.majorId != undefined && this.grade != undefined)
      return this.majorId + "_" + this.grade;
    return "";
  }

  static getMajorGradeFromKey(key: string): MajorGrade | null {
    if (key && key.indexOf("_")) {
      const splited: string[] = key.split("_");
      if (splited && splited.length === 2) {
        return new MajorGrade(Number(splited[0]), Number(splited[1]));
      }
    }
    return null;
  }
}
